"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.examLeaderboards = void 0;
var i18n_1 = __importDefault(require("../../i18n"));
var createLeaderboardRows = function (leadingRows) { return __spreadArray(__spreadArray([], leadingRows, true), Array.from({ length: 100 - leadingRows.length }, function (_, index) {
    var rank = leadingRows.length + index + 1;
    return {
        rank: rank,
        name: i18n_1.default.t("LEADERBOARD_ROW_PLACEHOLDER", { rank: rank }),
        score: Math.max(60, 95 - rank * 0.3)
    };
}), true); };
exports.examLeaderboards = [
    {
        examCode: "กพ.1",
        examTitle: "ความรู้ทั่วไป",
        updatedAt: i18n_1.default.t("LEADERBOARD_UPDATED_AT", {
            datetime: "01/07/2026 10:30"
        }),
        rows: createLeaderboardRows([
            { rank: 1, name: "นายธนกร สุขใจ", score: 98.2 },
            { rank: 2, name: "น.ส.วรัญญา ศรีทอง", score: 97.6 },
            { rank: 3, name: "นายพีรพัฒน์ นิลกุล", score: 96.9 },
            { rank: 4, name: "น.ส.ณัฐชยา สุขสวัสดิ์", score: 96.1 },
            { rank: 5, name: "นายกิตติภูมิ พัฒน์ชัย", score: 95.7 }
        ])
    },
    {
        examCode: "กพ.2",
        examTitle: "ภาษาไทยและการอ่านจับใจความ",
        updatedAt: i18n_1.default.t("LEADERBOARD_UPDATED_AT", {
            datetime: "01/07/2026 10:30"
        }),
        rows: createLeaderboardRows([
            { rank: 1, name: "น.ส.จุฑามาศ เพ็ชรดี", score: 97.9 },
            { rank: 2, name: "นายปกรณ์พงศ์ เจริญผล", score: 97.2 },
            { rank: 3, name: "น.ส.วรภัสร์ อินทร์แก้ว", score: 96.6 },
            { rank: 4, name: "นายธนวัฒน์ วงศ์ศรี", score: 95.9 },
            { rank: 5, name: "น.ส.พิมพ์ชนก บุญญา", score: 95.5 }
        ])
    },
    {
        examCode: "กพ.3",
        examTitle: "ภาษาอังกฤษ",
        updatedAt: i18n_1.default.t("LEADERBOARD_UPDATED_AT", {
            datetime: "01/07/2026 10:30"
        }),
        rows: createLeaderboardRows([
            { rank: 1, name: "นายณภัทร โชคชัย", score: 96.7 },
            { rank: 2, name: "น.ส.กรกนก ภูมิผล", score: 95.8 },
            { rank: 3, name: "นายรัชพล อัศวิน", score: 95.1 },
            { rank: 4, name: "น.ส.ชุติมา เพชรรัตน์", score: 94.8 },
            { rank: 5, name: "นายธีรภัทร์ วัฒนะ", score: 94.2 }
        ])
    },
    {
        examCode: "กพ.4",
        examTitle: "คณิตศาสตร์และเหตุผล",
        updatedAt: i18n_1.default.t("LEADERBOARD_UPDATED_AT", {
            datetime: "01/07/2026 10:30"
        }),
        rows: createLeaderboardRows([
            { rank: 1, name: "นายอธิป แก้ววงศ์", score: 98.9 },
            { rank: 2, name: "น.ส.ชลธิชา เพียรดี", score: 98.1 },
            { rank: 3, name: "นายภานุพงศ์ เรืองกิจ", score: 97.3 },
            { rank: 4, name: "น.ส.พรชนก เสนี", score: 96.7 },
            { rank: 5, name: "นายสิริชัย อนันต์", score: 96.0 }
        ])
    }
];
